import { forwardRef } from 'react';
import { SelectPrevClue, SelectNextClue } from "../../Actions"
import { DirectionClues } from "@bekodo/react-crossword"

const CluesMobile = forwardRef(({ label_across, label_down, id }, ref) => {
    return <div id={id} className="flex md:bg-orange_text w-full px-5 py-4">
        <div className="flex items-center" onClick={() => {
            SelectPrevClue(ref);
        }}>
            <img src={process.env.REACT_APP_ASSETSDIR + "fletxa-esquerra.png"} alt="fletxa esquerra" className="mr-5" />
        </div>
        <div id={"single_clue_container_" + id} style={{ display: 'none', width: "100%" }}>
            <DirectionClues direction="across" label={label_across} />
            <DirectionClues direction="down" label={label_down} />
        </div>
        <div className="flex items-center" onClick={() => {
            SelectNextClue(ref);
        }}>
            <img src={process.env.REACT_APP_ASSETSDIR + "fletxa-dreta.png"} alt="fletxa dreta" className="ml-5" />
        </div>
    </div>
})
export default CluesMobile
